import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Ge as u, hi as h, M as s } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as p } from "./state-b4c9cc73-ee633f6c.js";
import { i as f } from "./query-24926cff-3eb94bfb.js";
import { m as v } from "./query-assigned-nodes-2a11cfe9-176da62b.js";
import { r as y } from "./cta-variant-35c29d93-58108aa9.js";
import { A as g } from "./query-assigned-ba663908-228b08f4.js";
import { u as w } from "./form-associated-d3ceba31-80e8a7c4.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function I(t, o, r) {
  return t ? o(t) : r == null ? void 0 : r(t);
}
(function (t) {
  if (typeof t.requestSubmit == "function") return;
  t.requestSubmit = function (e) {
    e ? (o(e, this), e.click()) : (e = document.createElement("input"), e.type = "submit", e.hidden = !0, this.appendChild(e), e.click(), this.removeChild(e));
  };
  function o(e, n) {
    e instanceof HTMLElement || r(TypeError, "parameter 1 is not of type 'HTMLElement'"), e.type == "submit" || r(TypeError, "The specified element is not a submit button"), e.form == n || r(DOMException, "The specified element is not owned by this form element", "NotFoundError");
  }
  function r(e, n, c) {
    throw new e("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + n + ".", c);
  }
})(HTMLFormElement.prototype);
var m = /* @__PURE__ */function (t) {
    return t.LOADING = "loading", t.PROGRESS = "progress", t.SUCCESS = "success", t.RESULT = "result", t.NONE = "", t;
  }(m || {}),
  d = /* @__PURE__ */function (t) {
    return t.SUBMIT = "submit", t.BUTTON = "button", t.RESET = "reset", t.MENU = "menu", t;
  }(d || {});
var S = u(_templateObject || (_templateObject = _taggedTemplateLiteral(["[beacon-tag-name=beacon-button][icon-align=left]{--beacon-button-icon-align: start}.beacon-button-icon{align-self:var(--beacon-button-icon-align, center)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))))}\n"]))),
  T = u(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":is(button,a):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:0;position:relative;z-index:1}\n"])));
var E = Object.defineProperty,
  x = Object.getOwnPropertyDescriptor,
  a = function a(t, o, r, e) {
    for (var n = e > 1 ? void 0 : e ? x(o, r) : o, c = t.length - 1, l; c >= 0; c--) (l = t[c]) && (n = (e ? l(o, r, n) : l(n)) || n);
    return e && n && E(o, r, n), n;
  };
var b = {
    icon: "beacon-button-icon",
    strokeFill: "beacon-button-icon--stroke",
    iconFill: "beacon-button-icon--icon"
  },
  L = "stroke";
var i = /*#__PURE__*/function (_h) {
  _inherits(i, _h);
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.focusOverride = !0, _this.SLOTTED_ICON_INDEX = 0, _this.type = d.BUTTON, _this.variant = y.PRIMARY, _this.state = m.NONE, _this.disabled = !1, _this.linkHref = "";
    return _this;
  }
  _createClass(i, [{
    key: "cleanDefaultSlot",
    /**
     * Removes any whitespace from the default slot
     */
    value: function cleanDefaultSlot() {
      this.setDefaultLabelSlotText(), this.defaultLabelSlot && this.defaultLabelSlot.forEach(function (o) {
        var r;
        (r = o.textContent) != null && r.trim() || o.remove();
      });
    }
    /**
     * Sets @state  defaultLabelSlotText to default slot content
     */
  }, {
    key: "setDefaultLabelSlotText",
    value: function setDefaultLabelSlotText() {
      this.defaultLabelSlot && (this.defaultLabelSlotText = this.defaultLabelSlot.map(function (o) {
        var r, e;
        return (e = (r = o.textContent) == null ? void 0 : r.trim()) != null ? e : "";
      }).join(""));
    }
    /**
     * Returns the first element in the icon slot
     */
  }, {
    key: "handleClick",
    /**
     * Event listener for internal HTML button that
     * determines click behavior depending on its disabled state
     * and button type.
     * @param event click event
     * @event {BeaconEvents} beacon-event-click - Emits when clicked
     */
    value: function handleClick(o) {
      this.disabled ? (o.preventDefault(), o.stopPropagation(), o.stopImmediatePropagation()) : (this.emitClick(o), this.internals && this.type === d.SUBMIT && this.internals.form.requestSubmit());
    }
    /**
     * Applies proper CSS class to slotted SVG such that it renders correctly
     * @param element reference to the slotted SVG
     */
  }, {
    key: "applySVGClass",
    value: function applySVGClass(o) {
      o && Array.from(o.children).forEach(function (r) {
        if (r) {
          var e = r.getAttribute(L) ? b.strokeFill : b.iconFill;
          r.classList.add(e);
        }
      });
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this.icon && (this.icon.classList.add(b.icon), this.applySVGClass(this.icon)), this.setDefaultLabelSlotText();
    }
  }, {
    key: "icon",
    get: function get() {
      return this.iconElements[this.SLOTTED_ICON_INDEX];
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "styles", this), T];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "lightDOMStyles", this), S];
    }
  }]);
  return i;
}(h(w));
a([s({
  reflect: !0
})], i.prototype, "type", 2);
a([s({
  alternateSlot: "default",
  sync: !1
})], i.prototype, "label", 2);
a([s()], i.prototype, "variant", 2);
a([s()], i.prototype, "state", 2);
a([s({
  type: Boolean
})], i.prototype, "disabled", 2);
a([s({
  attribute: "link-href"
})], i.prototype, "linkHref", 2);
a([s({
  attribute: "link-download"
})], i.prototype, "linkDownload", 2);
a([s({
  attribute: "link-target"
})], i.prototype, "linkTarget", 2);
a([p()], i.prototype, "defaultLabelSlotText", 2);
a([g({
  flatten: !0,
  slot: "icon",
  selector: "svg"
})], i.prototype, "iconElements", 2);
a([f("button")], i.prototype, "button", 2);
a([v({
  slot: ""
})], i.prototype, "defaultLabelSlot", 2);
export { I as _, i };